export class AdminFacility {
  FacilityCode: string;
  FacilityName: string;
}
